import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import React, { Children } from 'react';
import { List } from 'semantic-ui-react';
import _isEmpty from 'lodash/isEmpty';
import { SocialAlignment } from './Social.constants';
import Handle from './components/Handle';
import Icon from './components/Icon';
import Label from './components/Label';
import Platform from './components/Platform';
import { classNames } from '../../../../utils/classname';
import { ChildrenPropType } from '../../types/component';
import './Social.css';
var defaultProps = {
  className: '',
  alignment: SocialAlignment.HORIZONTAL
};
export default function Social(_ref) {
  var children = _ref.children,
    className = _ref.className,
    alignment = _ref.alignment;
  var alignHorizontal = alignment.toLowerCase() === SocialAlignment.HORIZONTAL;
  var content = (Children.toArray(children) || []).filter(function (node) {
    return !_isEmpty(node);
  }).map(function (node) {
    var key = node.key;
    return /*#__PURE__*/React.createElement(List.Item, {
      key: key
    }, node);
  });
  var finalClassName = classNames(_defineProperty({
    'compound-social': true
  }, className, true));
  if (_isEmpty(content)) {
    return null;
  }
  return /*#__PURE__*/React.createElement(List, {
    className: finalClassName,
    horizontal: alignHorizontal
  }, content);
}
Social.defaultProps = defaultProps;
Social.Platform = Platform;
Social.Icon = Icon;
Social.Handle = Handle;
Social.Label = Label;